import ManageDiscontinuance from '../../../views/Personnel/Letter/ManageDiscontinuance.letter.view';

export default ManageDiscontinuance;
